import colors from '@constants/colors';
import { numberRegexp, phoneFormat, phoneRegExp } from '@constants/regexp';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import useProject from '@hooks/useProject';
import { ChangeEvent, useContext, useMemo } from 'react';

import useSendCode from './useSendCode';
import useVerification from './useVerification';
import SignUpContext from '../../../context/SignUpContext';

const ENABLED_COLOR = 'var(--color-blue)';
const SUCCESS_COLOR = 'var(--color-green)';
function useCertification() {
    const {
        useValue, useInputValue, useVerified, useInputAuthCode,
    } = useContext(SignUpContext);
    const isEmail = useIsEmailSignIn();
    const [inputValue, setInputValue] = useInputValue;
    const [certValue, setCertValue] = useValue;
    const [isVerified, setVerified] = useVerified;
    const [code, setCode] = useInputAuthCode;
    const requestColor = certValue ? SUCCESS_COLOR : ENABLED_COLOR;
    const verityColor = useMemo<string>(() => {
        if (isVerified) {
            return SUCCESS_COLOR;
        }
        if (certValue) {
            return ENABLED_COLOR;
        }
        return colors.gray5;
    }, [isVerified, certValue]);
    const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
        setVerified(false);
        setCertValue('');
        if (isEmail) {
            setInputValue(e.target.value);
        } else {
            setInputValue(e.target.value.replace(numberRegexp, '')
                .replace(phoneRegExp, phoneFormat));
        }
    };
    const onChangeCode = (e: ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value.replace(numberRegexp, ''));
    };
    const requestSms = useSendCode({ value: inputValue });
    const requestVerify = useVerification({ code });

    return {
        requestColor,
        verityColor,
        inputValue,
        onChangeValue,
        code,
        onChangeCode,
        certValue,
        isVerified,
        requestVerify,
        requestSms,
    };
}

export default useCertification;
